import { useMemo, useState, type JSX } from 'react';
import { Topbar } from './AdminLayout.js';
import { Icon } from '../components/Icon.js';
import { StatusChip } from '../components/ui.js';
import { MOCK } from '../mock.js';
import { fmtAmount, relativeTime } from '../utils/format.js';

type StatusFilter = 'all' | 'succeeded' | 'pending' | 'failed' | 'canceled';

const LABELS: Record<StatusFilter, string> = {
  all: 'Все',
  succeeded: 'Успешные',
  pending: 'В процессе',
  failed: 'Ошибки',
  canceled: 'Отменённые',
};

export function PaymentsList(): JSX.Element {
  const [status, setStatus] = useState<StatusFilter>('all');
  const [q, setQ] = useState('');

  const pays = useMemo(
    () =>
      MOCK.payments.filter((p) => {
        if (status !== 'all' && p.status !== status) return false;
        if (q) {
          const s = (p.customerName + p.customerEmail + p.productName).toLowerCase();
          if (!s.includes(q.toLowerCase())) return false;
        }
        return true;
      }),
    [status, q],
  );

  return (
    <>
      <Topbar title="Платежи" mock />
      <div style={{ padding: '24px 28px', flex: 1, overflowY: 'auto' }}>
        <div className="card">
          <div className="card-header" style={{ gap: 12 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, flex: 1 }}>
              <div style={{ position: 'relative', maxWidth: 280, flex: 1 }}>
                <div
                  style={{
                    position: 'absolute',
                    left: 10,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: 'var(--fg-subtle)',
                  }}
                >
                  <Icon name="search" size={14} />
                </div>
                <input
                  className="input"
                  placeholder="Имя, email, продукт…"
                  value={q}
                  onChange={(e) => setQ(e.target.value)}
                  style={{ paddingLeft: 32 }}
                />
              </div>
              <div className="seg">
                {(Object.keys(LABELS) as StatusFilter[]).map((s) => (
                  <button
                    key={s}
                    type="button"
                    className={status === s ? 'active' : ''}
                    onClick={() => setStatus(s)}
                  >
                    {LABELS[s]}
                  </button>
                ))}
              </div>
            </div>
            <div style={{ fontSize: 13, color: 'var(--fg-subtle)' }}>{pays.length}</div>
          </div>
          <table className="tbl">
            <thead>
              <tr>
                <th style={{ width: 110 }}>Статус</th>
                <th>Клиент</th>
                <th>Продукт</th>
                <th>Провайдер</th>
                <th style={{ textAlign: 'right' }}>Сумма</th>
                <th>Создан</th>
              </tr>
            </thead>
            <tbody>
              {pays.slice(0, 40).map((p) => (
                <tr key={p.id} className="no-hover">
                  <td>
                    <StatusChip status={p.status} />
                  </td>
                  <td>
                    <div style={{ fontWeight: 500 }}><bdi>{p.customerName}</bdi></div>
                    <div style={{ fontSize: 11.5, color: 'var(--fg-subtle)' }}>
                      {p.customerEmail}
                    </div>
                  </td>
                  <td>
                    <div style={{ fontSize: 13 }}><bdi>{p.productName}</bdi></div>
                    <div
                      className="mono"
                      style={{ fontSize: 11.5, color: 'var(--fg-subtle)' }}
                    >
                      {p.productSlug}
                    </div>
                  </td>
                  <td>
                    <span
                      className={
                        'chip no-dot ' + (p.provider === 'yookassa' ? 'chip-info' : 'chip-neutral')
                      }
                      style={{ fontSize: 10.5, height: 18 }}
                    >
                      {p.provider}
                    </span>
                  </td>
                  <td className="num" style={{ textAlign: 'right' }}>
                    <div style={{ fontWeight: 500 }}>{fmtAmount(p.amount, p.currency)}</div>
                    <div style={{ fontSize: 11, color: 'var(--fg-subtle)' }}>
                      {p.currency}
                    </div>
                  </td>
                  <td>
                    <span className="subtle" style={{ fontSize: 12.5 }}>
                      {relativeTime(p.createdAt)}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
